export default __webpack_public_path__ + "static/media/barlow-condensed.medium.b86496f1.ttf";